import HardwareCard from 'components/shared/HardwareCard/HardwareCard'
import PageSection from 'components/shared/PageSection/PageSection'
import PropTypes from 'prop-types'
import { withNamespaces } from 'react-i18next'
import logomark from '../../../components/shared/SiteHeader/images/logomark.svg'

import './Hardware.scss'
import hardwareCardsJson from './hardwareCards.json'

const { hardwareCards } = hardwareCardsJson

export const Hardware = ({
  locale,
  t,
  gtm = {},
  categories = hardwareCards,
}) => {
  return (
    <div id="hardware">
      <PageSection
        className={t('hardware__container')}
        title={t('homepage.hardware.title')}
        description={t('homepage.hardware.description')}
        image={{
          src: logomark,
          alt: 'Raspberry Pi Foundation',
        }}
      >
        {categories.map(({ id, url, image, title, gtm: { label } }) => (
          <HardwareCard
            key={id}
            locale={locale}
            url={url}
            image={{
              ...image,
              alt: title || t(`homepage.hardware.hardware_cards.${id}`),
            }}
            title={title || t(`homepage.hardware.hardware_cards.${id}`)}
            gtm={{
              ...gtm,
              label: label,
            }}
          />
        ))}
      </PageSection>
    </div>
  )
}

Hardware.propTypes = {
  locale: PropTypes.string.isRequired,
  t: PropTypes.func.isRequired,
  gtm: PropTypes.object,
  categories: PropTypes.array,
}

export default withNamespaces('translations')(Hardware)
